export function personName(givenNames?: string | null, familyName?: string | null): string {
    return [givenNames, familyName].map((part) => (part ?? '').trim()).filter(Boolean).join(' ');
}
